import React from 'react';
import { ButtonContained } from '@ntuctech/devex-tangram/Button';
import Grid from '@ntuctech/devex-tangram/Grid';
import styled from 'styled-components';
import { SCREEN_SIZE } from '../../lib/mediaQuery';
import { getVoucherDeepLink } from '../../lib/utils';
import { DEFAULT_TITLE } from '../../constants';

const UseEGiftSection = styled.div`
  h3 {
    font-family: 'Lato', serif;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 28px;
    color: #333333;
  }
  h6 {
    font-family: 'Lato', serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #333333;
  }
`;
const ButtonText = styled.span`
  font-family: 'Lato', serif;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #ffffff;
`;
const StoreBtn = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  ${SCREEN_SIZE.Only.Mobile} {
    margin-top: 15px;
  }
  ${SCREEN_SIZE.From.MobileL} {
    margin-top: 15px;
  }
`;
const RmvInnerPad = styled.div`
  ${SCREEN_SIZE.From.Tablet} {
    > div:nth-child(1) {
      padding: 0 0;
    }
    > div:nth-child(1) > div:nth-child(1) {
      padding-left: 0;
    }
    > div:nth-child(1) > div:nth-last-child(1) {
      padding-right: 0;
    }
  }
`;

const StoreVoucher = (props) => {
  const { code } = props;
  const storeVoucherDeeplink = getVoucherDeepLink(code);

  return (
    <UseEGiftSection>
      <RmvInnerPad>
        <Grid container>
          <Grid item s={7}>
            <h3>Use {DEFAULT_TITLE} later</h3>
            <h6>Store it digitally in your FairPrice account and use it anytime.</h6>
          </Grid>
          <Grid item s={1} />
          <Grid item s={4}>
            <StoreBtn>
              <ButtonContained
                fullWidth
                compact
                size="m"
                data-testid="store-voucher"
                onClick={() => {
                  window.open(storeVoucherDeeplink, '_blank');
                }}
              >
                <ButtonText size="xl">Save voucher</ButtonText>
              </ButtonContained>
            </StoreBtn>
          </Grid>
        </Grid>
      </RmvInnerPad>
    </UseEGiftSection>
  );
};

export default StoreVoucher;
